import type { StyleValue } from "@circle-react-shared/BuilderUI/StyleValue.types";

export const getListStyleTypeOptions = (
  defaultValue: string = "disc",
): StyleValue => ({
  type: "select",
  value: defaultValue,
});

export const getListStylePositionOptions = (
  defaultValue: string = "outside",
): StyleValue => ({
  type: "select",
  value: defaultValue,
});
